import axiosService from '../utils/axios';

async function getSpotifyArtists(query: string, limit: number = 40) {
    const { data } = await axiosService.get(
        `/spotify/artists/?query=${query}&limit=${limit}`
    );
    return data;
}

// This function now uses our own MongoDB genres collection instead of MusicDB API
// but maintains the same interface for backward compatibility
async function getSpotifyGenres(query: string, page: number = 0, limit: number = 50, includePopular: boolean = false) {
    const { data } = await axiosService.get(
        `/spotify/genres/?query=${query}&page=${page}&limit=${limit}${includePopular ? '&includePopular=true' : ''}`
    );
    return data;
}

async function getTrackDetails(spotifyTrackId: string) {
    const { data } = await axiosService.get(
        `/spotify/track/${spotifyTrackId}`
    );
    return data;
}

async function getPlaylistDetails(spotifyPlaylistId: string) {
    const { data } = await axiosService.get(
        `/spotify/playlist/${spotifyPlaylistId}`
    );
    return data;
}

async function getAlbumDetails(spotifyAlbumId: string) {
    const { data } = await axiosService.get(
        `/spotify/album/${spotifyAlbumId}`
    );
    return data;
}

export { getSpotifyArtists, getSpotifyGenres, getTrackDetails, getPlaylistDetails, getAlbumDetails };
